import React from 'react'

// import { closedPositionsQuery } from "../graphql/schema";
import BondPositionsTable from './BondPositionsTable'
import BondsHistoryTable from './BondsHistoryTable'
import { Translate } from 'react-redux-i18n'
import Spinner from './Spinner'
import { CouponInfo, BondClosedPosition, BondTrade, ViewerWrapper } from '../types'
import { closedPositionsQuery } from '../graphql/schema'
import {
  Trade,
  TradeObject,
  TradingAccount,
  PricesExtended,
  BondConfigItem,
} from '@bdswiss/mt4-connector'

export interface Props {
  accountLoaded: boolean
  assetLoaded: boolean
  opened: boolean
  currency: string
  locale: string
  assets: PricesExtended
  //   subscriptions: PricesExtended;
  positions: TradeObject[]
  bonds: BondConfigItem[]
  viewer: ViewerWrapper
  tradingAccount: TradingAccount
  closedPosQuery: closedPositionsQuery
  onCloseTrade: (order: number, uuid?: string) => void
  onToggleMenu: () => void
  tradeOperationEnabled: boolean
}

export interface State {
  filter: string
}

const BondPositionsPane = (props: Props) => {
  return <PositionsPaneContent {...props} />
}

class PositionsPaneContent extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.toggle = this.toggle.bind(this)
    this.state = { filter: 'open' }
  }

  public componentDidUpdate(nextProps: Props) {
    document.body.classList.toggle('positions-pane-opened', nextProps.opened)
  }

  public render() {
    const {
      accountLoaded,
      assetLoaded,
      opened,
      onToggleMenu,
      assets,
      positions,
      viewer,
      tradingAccount,
      closedPosQuery,
      currency,
      locale,
      onCloseTrade,
      tradeOperationEnabled,
      bonds,
    } = this.props
    const currentAccount = viewer.viewer.accounts.find(
      acc => acc.login === '' + tradingAccount.login
    )

    const bondOpenPositions: BondTrade[] = []
    positions.forEach(trade => {
      const bond = bonds.find(el => el.mt4Symbol === trade.symbol)
      const coupons: CouponInfo[] =
        currentAccount && currentAccount.coupons
          ? currentAccount.coupons.filter(coupon => coupon.ticket === trade.order)
          : []

      if (bond !== undefined) {
        bondOpenPositions.push({
          trade: trade as Trade,
          bond,
          coupons,
        })
      }
    })
    const bondClosedPositions: BondClosedPosition[] = []
    if (closedPosQuery.closedPositions != null) {
      closedPosQuery.closedPositions.forEach(closedTrade => {
        if (closedTrade !== null) {
          const bond = bonds.find(el => el.mt4Symbol === closedTrade.symbol)
          const coupons: CouponInfo[] =
            currentAccount && currentAccount.coupons
              ? currentAccount.coupons.filter(coupon => '' + coupon.ticket === closedTrade.id)
              : []
          if (bond !== undefined) {
            bondClosedPositions.push({
              closedTrade,
              bond,
              coupons,
            })
          }
        }
      })
    }

    const table =
      this.state.filter === 'open' ? (
        <BondPositionsTable
          assets={assets}
          bondsPositions={bondOpenPositions}
          locale={locale}
          onCloseTrade={onCloseTrade}
          currency={currency}
          accountLoaded={accountLoaded}
          tradeOperationEnabled={tradeOperationEnabled}
        />
      ) : (
        <BondsHistoryTable
          assets={assets}
          closedPositions={bondClosedPositions}
          currency={currency}
          locale={locale}
        />
      )
    return (
      <div className={'hidden-wrapper ' + (opened ? ' show' : '')} data-cy="positions">
        <div className="hidden-wrapper__header d-flex justify-content-between align-items-center">
          <div className="hidden-wrapper__title">
            <Translate value={'positions'} />
          </div>
          <button onClick={onToggleMenu} className="btn close_btn" data-cy="closePositionPane">
            <i className="icon-close" />
          </button>
        </div>
        <div>
          <div className="btn-group btn-group-toggle" data-toggle="buttons">
            <label
              className={'btn ' + (this.state.filter === 'open' ? 'active' : '')}
              data-cy="openPositions"
            >
              <input
                onClick={() => this.toggle('open')}
                type="radio"
                name="options"
                id="option1"
                autoComplete="off"
                defaultChecked={this.state.filter === 'open'}
              />
              <Translate value={'openPositions'} />
            </label>
            <label
              className={'btn ' + (this.state.filter === 'closed' ? 'active' : '')}
              data-cy="closedPositions"
            >
              <input
                onClick={() => this.toggle('closed')}
                type="radio"
                name="options"
                id="option3"
                autoComplete="off"
                defaultChecked={this.state.filter === 'closed'}
              />
              <Translate value={'closedPositions'} />
            </label>
          </div>
        </div>
        <div className="hidden-wrapper__content" data-cy="positionsTable">
          {!accountLoaded || !assetLoaded ? <Spinner /> : table}
        </div>
      </div>
    )
  }

  private toggle(filter: string) {
    this.setState(prevState => ({
      filter,
    }))
  }
}

export default BondPositionsPane
